import { c as _c } from "react/compiler-runtime";
import { InlinePillTableFilter } from "../table-filter";
import { useMemo } from "react";
import { useFiltersContext } from "./context";
import { useInlineFilterSetter } from "./edit-session";
import { getFilterIcon } from "./helpers";
import { useProviderOptions } from "./menu/use-provider-options";
import type { FilterTypeConfig } from "./types";
interface PillProps {
  filterType: FilterTypeConfig;
  options: FilterTypeConfig["options"];
  filterValue: any;
}
function Pill(t0) {
  const $ = _c(15);
  const {
    filterType,
    options,
    filterValue
  } = t0;
  const filterSetter = useInlineFilterSetter(filterType);
  const t1 = filterType.filterKey;
  const t2 = filterType.label;
  const t3 = filterType.type;
  const t4 = filterType.className;
  const t5 = filterType.disableClear;
  const t6 = filterType.allowFutureDates;
  const t7 = filterType.direction;
  let t8;
  if ($[0] !== filterType.filterKey || $[1] !== filterType.type) {
    t8 = getFilterIcon(filterType.type, filterType.filterKey);
    $[0] = filterType.filterKey;
    $[1] = filterType.type;
    $[2] = t8;
  } else {
    t8 = $[2];
  }
  let t9;
  if ($[3] !== filterSetter || $[4] !== filterType.allowFutureDates || $[5] !== filterType.className || $[6] !== filterType.direction || $[7] !== filterType.disableClear || $[8] !== filterType.filterKey || $[9] !== filterType.label || $[10] !== filterType.type || $[11] !== filterValue || $[12] !== options || $[13] !== t8) {
    t9 = <InlinePillTableFilter filterKey={t1} label={t2} type={t3} filterValue={filterValue} filterSetter={filterSetter} options={options} className={t4} disableClear={t5} allowFutureDates={t6} direction={t7} icon={t8} />;
    $[3] = filterSetter;
    $[4] = filterType.allowFutureDates;
    $[5] = filterType.className;
    $[6] = filterType.direction;
    $[7] = filterType.disableClear;
    $[8] = filterType.filterKey;
    $[9] = filterType.label;
    $[10] = filterType.type;
    $[11] = filterValue;
    $[12] = options;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}
const isEmptyValue = (v: any) => v === undefined || v === null || v === "" || Array.isArray(v) && v.length === 0;
export function ActivePills() {
  const $ = _c(14);
  const {
    filters,
    enhancedFilterTypes
  } = useFiltersContext();
  const getOptionsForFilter = useProviderOptions();
  let t0;
  if ($[0] !== enhancedFilterTypes || $[1] !== filters) {
    let t1;
    if ($[3] !== filters) {
      t1 = ft => ft.showByDefault || !isEmptyValue(filters[ft.filterKey]);
      $[3] = filters;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    t0 = enhancedFilterTypes.filter(t1);
    $[0] = enhancedFilterTypes;
    $[1] = filters;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const visibleFilters = t0;
  let t1;
  if ($[5] !== filters || $[6] !== getOptionsForFilter || $[7] !== visibleFilters) {
    let t2;
    if ($[9] !== filters || $[10] !== getOptionsForFilter) {
      t2 = filterType => <Pill key={filterType.filterKey} filterType={filterType} options={getOptionsForFilter(filterType)} filterValue={filters[filterType.filterKey]} />;
      $[9] = filters;
      $[10] = getOptionsForFilter;
      $[11] = t2;
    } else {
      t2 = $[11];
    }
    t1 = visibleFilters.map(t2);
    $[5] = filters;
    $[6] = getOptionsForFilter;
    $[7] = visibleFilters;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[12] !== t1) {
    t2 = <div className="flex flex-wrap items-center gap-1">{t1}</div>;
    $[12] = t1;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
}